// extracted by mini-css-extract-plugin
export default {"wrapper":"z1-z","play":"A1-z"};